import React from 'react';
import PropTypes from 'prop-types';
import CorrectIcon from '@learningblocks/exp-constants/lib/Images/correct-icon.svg';
import IncorrectIcon from '@learningblocks/exp-constants/lib/Images/incorrect-icon.svg';
import {Image} from '@learningblocks/storybook-components';

/**
 * TestTubeFeedback
 *  - The component that displays the feedback for LabelTestTube
 */
export function TestTubeFeedback({showFeedback, isCorrect}) {
  if (showFeedback) {
    let src = IncorrectIcon;
    if (isCorrect) {
      src = CorrectIcon;
    }
    return <Image className='tube-feedback' src={src} alt='feedback-icon' />;
  } else {
    return null;
  }
}

TestTubeFeedback.propTypes = {
  /**
   * Boolean value to display/hide the feedback
   */
  showFeedback: PropTypes.bool.isRequired,
  /**
   * Boolean specifying if submitted answer correct.
   */
  isCorrect: PropTypes.bool.isRequired,
};
